"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const framer_motion_1 = require("framer-motion");
const smartphone_bg_png_1 = __importDefault(require("images/stock/smartphone-bg.png"));
const smartphone_png_1 = __importDefault(require("images/stock/smartphone.png"));
/**
 * @name AnimationPhoneWait
 */
const AnimationPhoneWait = () => {
    // Animation Container
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                delay: 1.15,
                staggerChildren: 0.25,
            },
        },
    };
    // Animation Item
    const item = {
        hidden: { opacity: 0 },
        show: {
            opacity: [0, 1, 0],
            y: [0, 13, -15, 0],
            transition: {
                repeat: Infinity,
                repeatDelay: 0.5,
                repeatType: 'mirror',
            },
        },
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "check-phone-image", children: [(0, jsx_runtime_1.jsx)("div", { className: "phone-image", children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { initial: {
                        opacity: 0,
                        scale: 0.5,
                    }, animate: {
                        opacity: 1,
                        scale: 1,
                    }, transition: {
                        delay: 0.25,
                        duration: 0.5,
                    }, className: "animate-check-phone-image", children: (0, jsx_runtime_1.jsx)("img", { src: smartphone_png_1.default, alt: "phone" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "phone-animation", children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.ol, { variants: container, initial: "hidden", animate: "show", className: "animate-check-phone-image", children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.li, { variants: item, className: "animation_ball_bounce" }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.li, { variants: item, className: "animation_ball_bounce" }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.li, { variants: item, className: "animation_ball_bounce" })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "phone-bg", children: (0, jsx_runtime_1.jsx)("img", { src: smartphone_bg_png_1.default, alt: "phone" }) })] }));
};
exports.default = AnimationPhoneWait;
